module.exports = __webpack_public_path__ + "img/15.dde6fed.png";